import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {ENTITLEMENTS_SUB_TABS} from '../constants';
import {entitlementsSubTabTitle} from '../entitlements-subtab.module.styl';
import {EntitlementsTabBar} from '../entitlements-tabs';

import {EntitlementsTab} from './entitliments-tab';

type Props = {
    userId: number,
    accountId: number,
};

export const UserEntitlementsSubTab = ({userId, accountId}: Props) => (
    <>
        <EntitlementsTabBar
            userId={userId}
            activeSubTab={ENTITLEMENTS_SUB_TABS.USER_ENTITLEMENTS.name}
        />
        <div className={entitlementsSubTabTitle}>
            <StepHeader title={ENTITLEMENTS_SUB_TABS.USER_ENTITLEMENTS.caption}/>
        </div>
        <EntitlementsTab userId={userId} accountId={accountId}/>
    </>
);
